import { DatePicker, Layout } from 'antd';
import { styled } from 'styled-components';
import { IThemeSelectorProps } from 'components/ThemeSelector/ThemeSelector';
import { IToken } from 'store/ducks/globalTypes';
import { PlusCircleOutlined } from '@ant-design/icons';
import { PlusOutlined } from '@ant-design/icons';

export const TreeWrapper = styled.div<{ token?: any }>`
  padding: 16px;
  width: fit-content;
  margin: auto;

  .ant-tree {
    font-size: 16px;
    line-height: 1.6;
    background: transparent;
    min-height: 100vh;
  }

  .ant-tree-treenode {
    padding: 4px 0;
  }

  .ant-tree-switcher:not(.ant-tree-switcher-noop):hover::before,
  .ant-tree-switcher:not(.ant-tree-switcher-noop):hover::after {
    background: transparent !important;
  }

  /* Increase indentation for every tree level */
  .ant-tree-indent-unit {
    width: 100px;
  }

  .ant-tree-node-content-wrapper {
    padding: 6px 10px;
    border-radius: 8px;
    transition: all 0.2s ease;
    margin-left: 8px;
  }

  .ant-tree-node-content-wrapper:hover {
    transform: translateX(2px);
  }

  .ant-tree-switcher {
    display: flex;
    align-items: center;
  }

  .ant-tree-switcher-line-icon {
    color: ${({ token }) => token?.treeTextColor || 'inherit'} !important;
  }
`;

export const NodeContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const LabelBadge = styled.div<{ color: string }>`
  display: inline-block;
  align-self: flex-start;
  padding: 0 8px;
  font-size: 18px;
  font-weight: 600;
  border-radius: 6px;
  text-transform: uppercase;
  border-radius: 6px 6px 0px 0px;
  background: ${({ color }) => color};
  color: #fff;

  /* TABLET */
  @media (max-width: 1024px) {
    font-size: 16px;
  }

  /* MOBILE */
  @media (max-width: 768px) {
    font-size: 13px;
    padding: 2px 6px;
  }
`;

export const ValueCard = styled.div<{
  $bg: string;
  $border: string;
  $text: string;
}>`
  background: ${({ $text }) => $text};
  color: #fff;
  font-size: 22px;
  font-weight: 500;
  min-width: 450px;
  max-width: 450px;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  word-break: break-word;
  border-radius: 0px 12px 12px;
  padding: 12px;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);
  }

  /* TABLET */
  @media (max-width: 1024px) {
    width: 100%;
    font-size: 18px;
  }

  /* MOBILE */
  @media (max-width: 768px) {
    width: 100%;
    font-size: 16px;
    padding: 8px;
    gap: 8px;
  }
`;

export const InfoIcon = styled(PlusCircleOutlined)<{ color: string }>`
  color: ${({ color }) => color};
  cursor: pointer;
  font-size: 22px;
  transition: all 0.2s ease;

  &:hover {
    transform: scale(1.1);
    opacity: 0.85;
  }

  /* MOBILE */
  @media (max-width: 768px) {
    font-size: 18px;
  }
`;

export const StyledLayout = styled(Layout)<IToken>`
  min-height: 100vh;

  > .ant-layout {
    min-height: initial;

    .ant-layout-header {
      height: fit-content;
    }
  }

  aside {
    padding-right: ${(props) => `${props.token.paddingLG}px`};
    flex: initial !important;
    text-align: center;
    max-width: fit-content !important;
    min-width: fit-content !important;
    width: fit-content !important;
    position: relative !important;
    right: 0px;
  }

  h4 {
    text-align: center;
    font-size: 24px;
    font-weight: 700;
    margin: 0;
    padding-right: 34px;
  }

  /* TABLET */
  @media (max-width: 1024px) {
    h4 {
      font-size: 20px;
    }
  }

  /* MOBILE */
  @media (max-width: 768px) {
    aside {
      width: 100% !important;
      max-width: 100% !important;
      text-align: left;
    }

    h4 {
      font-size: 18px;
      padding-right: 0;
    }
  }
`;
export const HorizontalLayoutMain = styled('div')<IThemeSelectorProps>`
  @media (max-width: 1400px) {
    padding: 24px;
  }

  /* MOBILE */
  @media (max-width: 768px) {
    padding: 12px;
  }

  .ant-tabs-nav-list {
    width: -webkit-fill-available;
    margin-bottom: 1rem;

    .ant-tabs-tab {
      width: -webkit-fill-available;
      display: table;
    }
  }
`;

export const CustomSelectComponent = styled('div')`
  border: 1px solid lightgrey;
  padding: 16px 12px !important;
  margin: 20px;
  display: flex;
  gap: 20px;

  /* TABLET */
  @media (max-width: 1024px) {
    flex-wrap: wrap;
  }

  /* MOBILE */
  @media (max-width: 768px) {
    margin: 10px;
    padding: 12px !important;
    flex-direction: column;
    gap: 12px;
  }
`;

export const FilterLabel = styled.p`
  font-size: 13px;
  font-weight: 500;
  color: #4b5563;
  margin-top: 0;
`;

export const FilterItem = styled.div`
  display: flex;
  flex-direction: column;

  /* MOBILE */
  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const SmallDatePicker = styled(DatePicker)`
  .ant-picker {
    width: 162px;
  }

  /* MOBILE */
  @media (max-width: 768px) {
    .ant-picker {
      width: 100%;
    }
  }
`;

export const PopoverContentDiv = styled('div')`
  min-width: 360px;
  color: inherit;

  strong {
    font-size: 16px;
    color: inherit;
  }

  span {
    font-size: 18px;
    color: inherit;
  }

  /* TABLET */
  @media (max-width: 1024px) {
    min-width: 280px;
  }

  /* MOBILE */
  @media (max-width: 768px) {
    min-width: 240px;

    strong,
    span {
      font-size: 14px;
    }
  }
`;

export const ValueContent = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const PlusIcon = styled(PlusOutlined)<{ color: string }>`
  color: ${({ color }) => color};
  font-size: 20px;
  flex-shrink: 0;
`;
